"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDay = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var CalendarDay = function (_a) {
    var dateInFocus = _a.dateInFocus, day = _a.day, focusDate = _a.focusDate, id = _a.id, inFocus = _a.inFocus, isDaySelectable = _a.isDaySelectable, isFirstDay = _a.isFirstDay, isLastDay = _a.isLastDay, isSelected = _a.isSelected, month = _a.month, onDayClick = _a.onDayClick, year = _a.year;
    var isFocusedStateOn = focusDate.getDate() === day && focusDate.getMonth() === month && dateInFocus && isDaySelectable;
    var activeButton = focusDate.getDate() === day && focusDate.getMonth() === month && isDaySelectable && inFocus;
    var classNames = (0, classnames_1.default)('calendar__date p-0', {
        'calendar__date--selectable': isDaySelectable,
        'calendar__date--selected': isSelected,
        'calendar__date--unselectable': !isDaySelectable,
        'calendar__date-first--selected': isFirstDay,
        'calendar__date-last--selected': isLastDay,
    });
    var buttonClassNames = (0, classnames_1.default)('m-0 p-0 btn-action--subtle', {
        'btn-action--emphasis': isFirstDay || isLastDay,
        'btn-active': isFocusedStateOn,
    });
    var attributes = {
        className: classNames,
        'data-day': day,
        'data-month': month,
        'data-year': year,
        'key': "calendar-" + id + "-day-" + day,
        onClick: onDayClick,
    };
    var buttonAttributes = {
        className: buttonClassNames,
        'data-date': day + "-" + (month + 1) + "-" + year,
        disabled: !isDaySelectable,
        tabIndex: activeButton ? 0 : -1,
    };
    return (React.createElement("td", __assign({}, attributes),
        React.createElement("button", __assign({ type: "button" }, buttonAttributes), ("" + day).padStart(2, '0'))));
};
exports.CalendarDay = CalendarDay;
exports.CalendarDay.prototype = {
    day: PropTypes.number.isRequired,
    dayInFocus: PropTypes.bool.isRequired,
    focusDate: PropTypes.instanceOf(Date).isRequired,
    id: PropTypes.string.isRequired,
    inFocus: PropTypes.bool.isRequired,
    isDaySelectable: PropTypes.bool,
    isFirstDay: PropTypes.bool,
    isLastDay: PropTypes.bool,
    isSelected: PropTypes.number.isRequired,
    month: PropTypes.number,
    onDayClick: PropTypes.func.isRequired,
    year: PropTypes.number.isRequired,
};
exports.default = exports.CalendarDay;
